module.exports = __webpack_public_path__ + "media/recipes/41-17d71902.png";